import { useGet } from '@app/sdk';
import { useQuery } from '@tanstack/react-query';

export function useStatementSubmissions(cycleDate?: string) {
  const get = useGet(true, 'cus');

  function getSubmissions(cycleDate: string) {
    return get<{ ids: string[] }>(`/api/proxy/cus/customer-output-service/submissions/ids?cycleDate=${cycleDate}`);
  }

  return useQuery({
    queryKey: [`submissions@${cycleDate}`],
    queryFn: () => getSubmissions(cycleDate),
    enabled: !!cycleDate,
  });
}